<div class="full-screen-loader twc-loader-overlay-dark" *ngIf="loading$ | async">
    <div class="twc-loader">
        <svg xmlns="http://www.w3.org/2000/svg" class="twc-loader-svg" viewBox="0 0 80 80">
            <circle class="twc-loader-circle" cx="50%" cy="50%" r="37" stroke-width="6"></circle>
        </svg>
    </div>
</div>